import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { BrowserRouter as Router } from "react-router-dom";
import enUS from "antd/lib/locale/en_US";
import { ConfigProvider } from "antd";
import { Provider } from "react-redux";
import { persistor, store } from "@stores";
import { PersistGate } from "redux-persist/integration/react";
import { QueryClient, QueryClientProvider } from "react-query";
import { AuthProvider } from "@pages/auth/AuthContext";
import AppRoutes from "@routes/AppRoutes";
import ServiceWorkerPopup from "./ServiceWorkerPopup";



function App() {
  const queryClient = new QueryClient();

  return (
    <Provider store={store}>

      <Router>   {/* move Router UP */}

        <PersistGate loading={null} persistor={persistor}>
          <AuthProvider>
            <ConfigProvider
              theme={{
                components: {
                  Button: { colorPrimary: "#0D9276", algorithm: true },
                  Menu: { colorPrimary: "#FCF6F5", algorithm: true },
                },
              }}
              locale={enUS}
            >
              <QueryClientProvider client={queryClient}>


                <AppRoutes />            
                

              </QueryClientProvider>
            </ConfigProvider>
          </AuthProvider>
        </PersistGate>

      </Router>

    </Provider>
  );
}

export default App;
